import axios, { InternalAxiosRequestConfig } from "axios";

// Platform API
export const defaultApi = axios.create({
  baseURL: "https://api.vps2.online/",
});

export const admissionDatabaseBaseUrl = "https://qarshisu.net/";
export const admissionDatabaseApi = axios.create({
  baseURL: admissionDatabaseBaseUrl,
});

// Add token to API
const attachToken = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const accessToken = localStorage.getItem("accessToken") || "";

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
};

defaultApi.interceptors.request.use(attachToken, (error) => Promise.reject(error));
admissionDatabaseApi.interceptors.request.use(attachToken, (error) => Promise.reject(error));
